import { CommonModule } from "@angular/common";
import {
    AfterContentChecked,
    Component,
    computed,
    contentChildren,
    input,
} from "@angular/core";
import { Button } from "../button/button.component";
import { BaseConfig } from "../common/config/config.adapter";
import { Color, Rounded, Size, Variant } from "../common/types";

@Component({
    selector: "app-button-group",
    templateUrl: "./button-group.component.html",
    styleUrls: ["./button-group.component.scss"],
    imports: [Button, CommonModule],
})
export class ButtonGroup extends BaseConfig implements AfterContentChecked {
    children = contentChildren(Button);

    size = input<Size>();
    color = input<Color>();
    rounded = input<Rounded>();
    variant = input<Variant>("solid");

    config = computed(() => this.globalConfig()?.button);
    currentSize = computed(() => this.size() || this.config()?.size || "md");
    currentColor = computed(
        () => this.color() || this.config()?.color || "primary",
    );
    currentRounded = computed(
        () => this.rounded() || this.config()?.rounded || "md",
    );

    ngAfterContentChecked(): void {
        this.children().map((child, index) => {
            child._rounded.set("none");
            child._size.set(this.currentSize());
            child._variant.set(this.variant());
            child._color.set(this.currentColor());
            child._class.set("!border-t-0 !border-b-0 !border-l-0");
            if (index === this.children().length - 1) {
                child._class.set(
                    "!border-t-0 !border-b-0 !border-l-0 !border-r-0",
                );
            }
        });
    }
}
